/*
 * Copyright (c) 2026. World Wide Generation Ltd
 */

import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { generateUrl } from '@routes/util';
import { emissionsTrackerRoutes } from '@apps/emissions-tracker/routes';
import type { BaseStepCompProps } from '@features/onboarding/types';
import { getAnalytics } from '@services/analytics/AnalyticsService';
import { AnalyticsEvents } from '@services/analytics/AnalyticsEvents';

type Props = Pick<BaseStepCompProps, 'appConfig'>;

export const CompletedET = ({ appConfig: _appConfig }: Props) => {
  const history = useHistory();

  const redirect = () => {
    console.log('go to', generateUrl(emissionsTrackerRoutes.EMISSIONS_TRACKER, {}));

    history.push(generateUrl(emissionsTrackerRoutes.EMISSIONS_TRACKER, {}));
  };

  useEffect(() => {
    getAnalytics().track(AnalyticsEvents.OnboardingCompleted);
  }, []);

  return (
    <>
      <section className='title-container'>
        <div className='h1'>Done!</div>
        <div className='h4 text-strong mb-3'>Your account is now ready!</div>
      </section>
      <div className='mt-5 text-right mr-3'>
        <Button color='primary' onClick={redirect}>
          Continue to Emissions Tracker
        </Button>
      </div>
    </>
  );
};
